module.exports = __webpack_public_path__ + "static/media/xuanqi_match_02.59e49cf8.png";